"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mode = exports.outputSource = exports.outputAttribution = exports.prettifyOutput = exports.solidityVersion = exports.license = exports.name = void 0;
const options_1 = require("./options");
exports.name = "MyInterface";
exports.license = "UNLICENSED";
exports.solidityVersion = ">=0.7.0 <0.9.0";
exports.prettifyOutput = true;
exports.outputAttribution = true;
exports.outputSource = true;
exports.mode = options_1.GenerateSolidityMode.Normal;
//# sourceMappingURL=defaults.js.map